module.exports = __webpack_public_path__ + "static/img/mood9.35370f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood9.png
// module id = JTq7
// module chunks = 1